'use strict';

(function ($) {
  $.fn.getCursorPosition = function () {
    var input = this.get(0);
    if (!input) {
      return; // No (input) element found
    }

    if ('selectionStart' in input) {
      // Standard-compliant browsers
      return input.selectionStart;
    } else if (document.selection) {
      // IE
      input.focus();
      var sel = document.selection.createRange();
      var selLen = document.selection.createRange().text.length;
      sel.moveStart('character', -input.value.length);
      return sel.text.length - selLen;
    }
  };
})(jQuery);
